import '../../styles/templates/collection.pcss';
import '../ui/collection/collection';

import {Pager} from '../ui/pager';
import '../ui/pager/pager.pcss';

new Pager();
